<template>
  <div class="recommend-work-component">
    <div class="header active">
      <span>相关作品</span>
      <span class="more"
            @click="handleMoreWork(challengeId)"
      >
        更多
        <ym-icon name="right"
        />
      </span>
    </div>
    <div class="recommend-work-list">
      <div v-for="(item, index) in recommendWorkList"
           :key="index"
      >
        <work-item :item="item" />
      </div>
    </div>
  </div>
</template>

<script>
  import WorkItem from '@/pages/Work/components/RecommendWorkItem';

  export default {
    name: 'RecommendWorkComponent',
    components: {
      WorkItem,
    },
    props: {
      recommendWorkList: {
        type: Array,
        required: true,
        default() {
          return [];
        },
      },
      challengeId: {
        type: Number,
        required: true,
      },
    },
    methods: {
      handleMoreWork(targetId) {
        const route = { name: 'WorkList', query: { targetId, targetType: 'challenge' } };
        this.$router.push(route);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .recommend-work-component {
    margin-bottom: @size-small;
    background: @color-white;
  }

  .header {
    padding: @size-base;
    font-size: @font-size-medium;
    font-weight: @font-weight-primary;
    color: @color-text-base;
    line-height: 1;
    border-bottom: @border-base;
    &.active {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .more {
      font-size: @font-size-base;
      font-weight: @font-weight-primary;
      color: @color-text-lighter;
    }
  }

</style>
